<div *ngIf="invalidContext; else validContext">
  <h3 class="panel-title">Hmm...</h3>
  Somehow you've arrived here without the required URL parameters to perform a password reset. Do you mind checking the
  link in your email and trying again?
</div>
<ng-template #validContext>
  <ng-container *ngIf="!!userEmail">
    <h3 class="panel-title">Reset password for {{ userEmail }}</h3>
    <form
      [formGroup]="resetPasswordFormModel"
      (ngSubmit)="resetPassword()"
      *ngIf="!resetSuccessful; else successfulBlock"
    >
      <div class="flex-center-column light-control-host">
        <div class="full-width margin-top">Give us a new password and we'll get you fixed up.</div>
        <div class="flex-center-row full-width margin-top field-issue-container">
          <input
            id="reset-pword"
            class="arpio-input"
            type="password"
            placeholder="Password"
            formControlName="password"
            autocomplete="new-password"
          />
          <div class="field-issue" *ngIf="!!passwordError">
            <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ passwordError }}
          </div>
        </div>
        <div class="flex-center-row full-width field-issue-container">
          <input
            id="confirm-pword"
            class="arpio-input"
            type="password"
            placeholder="Confirm password"
            formControlName="confirmPassword"
            autocomplete="new-password"
          />
          <div class="field-issue" *ngIf="!!confirmPasswordError">
            <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ confirmPasswordError }}
          </div>
        </div>

        <button
          busy-button
          [busy]="resetInProgress"
          class="arpio-button"
          type="submit"
          [disabled]="!resetButtonEnabled"
        >
          RESET PASSWORD
        </button>
      </div>
    </form>

    <ng-template #successfulBlock>
      Your password has been updated! <a routerLink="{{ uiService.buildLoginUrl() }}">Click here</a> to login.
    </ng-template>
  </ng-container>
</ng-template>
